const CanMixin = {
	computed: {
		canExportLUT() {
			if (!this.$store.state.User.user) return;
			if (!this.$store.state.User.user.activeSubscription) return;
			if (this.$store.state.User.user.activeSubscription.product.sku !== 'professional') return;

			return true;
		},
		exportLUTBindings() {
			if (!this.canExportLUT)
				return {
					"data-tippy-content": "Available in Professional plans only",
				};
		},
		canUsePresets() {
			// if (this.$store.state.User.account.plan_id == 1) return false;
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		presetsBindings() {
			if (!this.canUsePresets)
				return {
					"data-tippy-content": "Available for Members role and higher",
				};
		},
		canCreateProject() {
			if (this.$store.state.User.account.plan_id == 1 && this.$store.state.Projects.projects.length >= 3) return false;
			if (this.$store.state.User.account.role_id >= 5) return false;
			else return true;
		},
		canDeleteProject() {
			if (this.$store.state.User.account.role_id >= 4) return false;
			else return true;
		},
		canRenameProject() {
			if (this.$store.state.User.account.role_id >= 4) return false;
			else return true;
		},
		canUploadFiles() {
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		canCreateBin() {
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		canRenameBin() {
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		canDeleteBin() {
			if (this.$store.state.User.account.role_id >= 5) return false;
			else return true;
		},
		canCreateAssets() {
			return true;
		},
		canShareAsset() {
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		canAssignTagToAsset() {
			if (this.$store.state.User.account.role_id == 6) return false;
			else return true;
		},
		canCopyAsset() {
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		canRenameAsset() {
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		canDeleteAsset() {
			if (this.$store.state.User.account.role_id >= 5) return false;
			if (this.$store.state.User.account.role_id == 4 && this.$store.state.Projects.project.owner.id !== this.$store.state.User.user.id)
				return false;
			else return true;
		},
		canArchiveAsset() {
			if (this.$store.state.User.account.role_id >= 5) return false;
			else return true;
		},
		canRestoreAsset() {
			if (this.$store.state.User.account.role_id >= 5) return false;
			else return true;
		},
		canUseColorGradingTools() {
			return true;
		},
		canSyncImageState() {
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		canAddToSelects() {
			if (this.$store.state.User.account.role_id >= 6) return false;
			else return true;
		},
		canAssignUsersAndGroups() {
			if (this.$store.state.User.account.role_id >= 5) return false;
			else return true;
		},

		// accounts pages
		canEditOrganization() {
			if (this.$store.state.User.account.role_id >= 3) return false;
			else return true;
		},

		canSeePlan() {
			if (this.$store.state.User.account.role_id >= 3) return false;
			else return true;
		},

		canSeeBillingPage() {
			if (this.$store.state.User.account.role_id >= 3) return false;
			else return true;
		},

		canSeeGroupsPage() {
			if (this.$store.state.User.account.plan_id !== 6) return false;
			if (this.$store.state.User.account.role_id >= 5) return false;
			else return true;
		},

		canUseGroups() {
			if (this.$store.state.User.account.plan_id == 6) return true;
			else return false;
		},

		canLeaveOrganization() {
			if (this.$store.state.User.account.role_id >= 3) return true;
			else return false;
		},

		canSeeProjectManagementPage() {
			if (this.$store.state.User.account.role_id >= 5) return false;
			else return true;
		},

		canSeeInvitationsPage() {
			if (this.$store.state.User.account.role_id >= 3 || this.$store.state.User.account.plan_id == 1) return false;
			else return true;
		},

		canSeeEmailNotificationsPage() {
			if (this.$store.state.User.account.plan_id == 1) return false;
			else return true;
		},

		canSeeUsersPage() {
			if (this.$store.state.User.account.role_id >= 5 || this.$store.state.User.account.plan_id == 1) return false;
			else return true;
		},

		canSeeGuestsPage() {
			if (this.$store.state.User.account.role_id >= 5 || this.$store.state.User.account.plan_id == 1) return false;
			else return true;
		},

		canViewInvitations() {
			if (this.$store.state.User.account.plan_id == 2 || this.$store.state.User.account.plan_id == 3) {
				if (this.$store.state.User.account.role_id <= 2) {
					return true;
				}
			}

			if (this.$store.state.User.account.plan_id >= 4) {
				if (this.$store.state.User.account.role_id <= 4) {
					return true;
				}
			}

			return false;
		},

		canInviteUsers() {
			// if (this.$store.state.User.account.plan_id == 1) return false;
			if (this.$store.state.User.account.role_id >= 3) return false;
			else return true;
		},

		canInviteGuests() {
			// if (this.$store.state.User.account.plan_id == 1) return false;
			if (this.$store.state.User.account.role_id >= 3) return false;
			else return true;
		},

		canDeleteUsers() {
			if (this.$store.state.User.account.role_id >= 3) return false;
			else return true;
		},
	},
	methods: {
		canAssignUsersToProject(project) {
			// if (this.$store.state.User.account.role_id == 4) {
			// 	return this.$store.getters["User/isOwnerOfProject"](project);
			// }
			if (this.$store.state.User.account.role_id >= 5) return false;
			else return true;
		},
	},
};

export default CanMixin;
